import { t } from 'i18next';

export enum SaleType {
  Ongoing = 'ongoing',
  Next = 'next',
  Ended = 'ended',
  Cancelled = 'cancelled',
}

export const saleTypes = [
  {
    id: SaleType.Ongoing,
    name: t('sales_page.tabs.active'),
    pageTitle: t('sales_page.tab_urls.active'),
  },
  {
    id: SaleType.Next,
    name: t('sales_page.tabs.upcoming'),
    pageTitle: t('sales_page.tab_urls.upcoming'),
  },
  {
    id: SaleType.Ended,
    name: t('sales_page.tabs.over'),
    pageTitle: t('sales_page.tab_urls.over'),
  },
  {
    id: SaleType.Cancelled,
    name: t('sales_page.tabs.cancelled'),
    pageTitle: t('sales_page.tab_urls.cancelled'),
  },
];
